import { render } from "./MediaControls.vue?vue&type=template&id=6fb7fd92"
import script from "./MediaControls.vue?vue&type=script&lang=js"
export * from "./MediaControls.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__